// Import Vue
import Vue from "vue";

import "./plugins";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import idb from "./plugins/indexdb";
import "./registerServiceWorker";

import VueOffline from "vue-offline";
import Notifications from "vue-notification";

Vue.use(VueOffline);
Vue.use(Notifications);

// VeeValidate
import "./plugins/veeValidate";
import "./plugins/sweet-alert";

// Filters
import "./filters/filters";

import axios from "axios";

const LOG_SERVER_URL =
  "https://alan-logs.01fcd5fc-1999-4318-8a8d-fa03a38e9dd5.nodes.k8s.fr-par.scw.cloud/sendRawData";

function sendLog(log) {
  axios.post(LOG_SERVER_URL, { data: JSON.stringify(log) });
}

window.onerror = function(message, source, lineno, colno, error) {
  sendLog({
    message,
    source,
    lineno,
    colno,
    error,
  });
};

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  idb: idb,
  render: (h) => h(App),
}).$mount("#app");
